export default [
  [
    {
      id: 1,
      class: 'header-row',
      title: 'Raw Data',
      collapsible: true,
      opened: true,
      CityFALCON: {
        class: 'green',
        text: 'High',
      },
      Finance: {
        class: 'orange',
        text: 'Medium',
      },
      Twitter: {
        class: 'red',
        text: 'Low',
      },
      Premium: {
        class: 'green',
        text: 'High',
      },
    },
    {
      id: 2,
      class: '',
      title: 'News',
      CityFALCON: {
        class: 'green',
        text: 'Yes',
      },
      Finance: {
        class: 'green',
        text: 'Yes',
      },
      Twitter: {
        class: 'green',
        text: 'Yes',
      },
      Premium: {
        class: 'green',
        text: 'Yes',
      },
    },
    {
      id: 3,
      class: '',
      title: 'Paywall-free and Non-public Content',
      CityFALCON: {
        class: 'orange',
        text: 'Some*',
      },
      Finance: {
        class: 'red',
        text: 'No',
      },
      Twitter: {
        class: 'red',
        text: 'No',
      },
      Premium: {
        class: 'orange',
        text: 'Some',
      },
    },
    {
      id: 4,
      class: '',
      title: 'Research and Analyst Reports',
      CityFALCON: {
        class: 'orange',
        text: 'Some*',
      },
      Finance: {
        class: 'red',
        text: 'No',
      },
      Twitter: {
        class: 'red',
        text: 'No',
      },
      Premium: {
        class: 'orange',
        text: 'Some',
      },
    },
    {
      id: 5,
      class: '',
      title: 'Prices and Charts, Fundamental Data',
      CityFALCON: {
        class: '',
        text: 'Coming Soon',
      },
      Finance: {
        class: 'green',
        text: 'Yes',
      },
      Twitter: {
        class: 'red',
        text: 'No',
      },
      Premium: {
        class: 'green',
        text: 'Yes',
      },
    },
    {
      id: 6,
      class: '',
      title: 'Company Filings',
      CityFALCON: {
        class: 'orange',
        text: 'Some*',
      },
      Finance: {
        class: 'red',
        text: 'No',
      },
      Twitter: {
        class: 'red',
        text: 'No',
      },
      Premium: {
        class: 'orange',
        text: 'Some',
      },
    },
    {
      id: 7,
      class: '',
      title: 'Alternative Data',
      CityFALCON: {
        class: 'orange',
        text: 'Some*',
      },
      Finance: {
        class: 'red',
        text: 'No',
      },
      Twitter: {
        class: 'orange',
        text: 'Some',
      },
      Premium: {
        class: 'orange',
        text: 'Some',
      },
    },
  ],
  [
    {
      id: 8,
      class: 'header-row',
      title: 'Topics Coverage',
      collapsible: true,
      CityFALCON: {
        class: 'green',
        text: 'High',
      },
      Finance: {
        class: 'orange',
        text: 'Medium',
      },
      Twitter: {
        class: 'red',
        text: 'Low',
      },
      Premium: {
        class: 'orange',
        text: 'Medium',
      },
    },
    {
      id: 9,
      class: '',
      title: 'Topic and Asset Classes',
      CityFALCON: {
        class: 'green',
        text: 'All Asset Classes',
      },
      Finance: {
        class: 'orange',
        text: 'Limited',
      },
      Twitter: {
        class: 'orange',
        text: 'Limited',
      },
      Premium: {
        class: 'orange',
        text: 'Limited',
      },
    },
    {
      id: 10,
      class: '',
      title: 'Country Coverage',
      CityFALCON: {
        class: 'green',
        text: 'Global',
      },
      Finance: {
        class: 'green',
        text: 'Global',
      },
      Twitter: {
        class: 'green',
        text: 'Global',
      },
      Premium: {
        class: 'orange',
        text: 'Limited',
      },
    },
    {
      id: 11,
      class: '',
      title: 'Languages',
      CityFALCON: {
        class: 'green',
        text: '30+ going to 90+',
      },
      Finance: {
        class: 'green',
        text: 'Global',
      },
      Twitter: {
        class: 'green',
        text: 'Global',
      },
      Premium: {
        class: 'orange',
        text: 'Mainly English and a few more languages',
      },
    },
  ],
  [
    {
      id: 12,
      class: 'header-row',
      title: 'Analytics and Insights',
      CityFALCON: {
        class: 'orange',
        text: 'Some*',
      },
      Finance: {
        class: 'orange',
        text: 'Some',
      },
      Twitter: {
        class: 'red',
        text: 'No',
      },
      Premium: {
        class: 'orange',
        text: 'Some',
      },
    },
  ],
  [
    {
      id: 13,
      class: 'header-row',
      title: 'Latency',
      subtitle: 'Relative delay in capturing stories and trends',
      CityFALCON: {
        class: 'green',
        text: 'Fast',
      },
      Finance: {
        class: 'red',
        text: 'Slow',
      },
      Twitter: {
        class: 'green',
        text: 'Fast',
      },
      Premium: {
        class: 'green',
        text: 'Fast',
      },
    },
  ],
  [
    {
      id: 14,
      class: 'header-row',
      title: 'Structure',
      collapsible: true,
      CityFALCON: {
        class: 'green',
        text: 'High',
      },
      Finance: {
        class: 'orange',
        text: 'Medium',
      },
      Twitter: {
        class: 'red',
        text: 'Low',
      },
      Premium: {
        class: 'orange',
        text: 'Medium',
      },
    },
    {
      id: 15,
      class: '',
      title: 'Tools: Watchlists, Trending',
      CityFALCON: {
        class: 'green',
        text: 'Yes',
      },
      Finance: {
        class: 'green',
        text: 'Yes',
      },
      Twitter: {
        class: 'red',
        text: 'No',
      },
      Premium: {
        class: 'green',
        text: 'Yes',
      },
    },
    {
      id: 16,
      class: '',
      title: 'Filtration and Curation',
      CityFALCON: {
        class: 'green',
        text: 'Yes',
      },
      Finance: {
        class: 'orange',
        text: 'Some',
      },
      Twitter: {
        class: 'red',
        text: 'No',
      },
      Premium: {
        class: 'orange',
        text: 'Some',
      },
    },
    {
      id: 17,
      class: '',
      title: 'Ease of Use and User Experience',
      CityFALCON: {
        class: 'green',
        text: 'High',
      },
      Finance: {
        class: 'green',
        text: 'High',
      },
      Twitter: {
        class: 'green',
        text: 'High',
      },
      Premium: {
        class: 'red',
        text: 'Low',
      },
    },
    {
      id: 18,
      class: '',
      title: 'Similar Content Grouping',
      CityFALCON: {
        class: 'green',
        text: 'Yes',
      },
      Finance: {
        class: 'green',
        text: 'Yes',
      },
      Twitter: {
        class: 'red',
        text: 'No',
      },
      Premium: {
        class: 'orange',
        text: 'Maybe',
      },
    },
    {
      id: 19,
      class: '',
      title: 'NLU Indexing',
      CityFALCON: {
        class: 'green',
        text: 'Yes',
      },
      Finance: {
        class: 'green',
        text: 'Yes',
      },
      Twitter: {
        class: 'red',
        text: 'No',
      },
      Premium: {
        class: 'orange',
        text: 'Maybe',
      },
    },
  ],
  [
    {
      id: 20,
      class: 'header-row',
      title: 'Relevancy and Personalisation',
      CityFALCON: {
        class: 'green',
        text: 'High',
      },
      Finance: {
        class: 'orange',
        text: 'Medium',
      },
      Twitter: {
        class: 'red',
        text: 'Low',
      },
      Premium: {
        class: 'orange',
        text: 'Medium',
      },
    },
  ],
  [
    {
      id: 21,
      class: 'header-row',
      title: 'Cost',
      CityFALCON: {
        class: 'orange',
        text: 'Free / £ ',
      },
      Finance: {
        class: 'green',
        text: 'Free',
      },
      Twitter: {
        class: 'orange',
        text: 'Free / (£ for API) ',
      },
      Premium: {
        class: 'red',
        text: '£££',
      },
    },
  ],
];
